import { lazy } from "react";
import { historicalInfoSVG } from '../shared/helpers/icons';

const EntryPoint = lazy(() => import(/* webpackChunkName: "transmission" */ './components/EntryPoint'));
const TransmissionLoader = lazy(() => import(/* webpackChunkName: "transmissionLoader" */ './components/HistoricalLoader'));

export const defaultPath = '/historical';

export const innerRoutes = [
    {
        path: `${defaultPath}/:imei`,
        Component: TransmissionLoader,
        exact: true,
        icon: historicalInfoSVG,
        title: {
            key: '',
            plural: false
        },
        subTitle: {
            key: '',
            plural: false
        }
    },
    {
        path: `${defaultPath}/`,
        Component: TransmissionLoader,
        exact: true,
        icon: historicalInfoSVG,
        title: {
            key: '',
            plural: false
        },
        subTitle: {
            key: '',
            plural: false
        }
    }
];

const Stock = {
    path: defaultPath,
    Component: EntryPoint,
    exact: false,
    icon: historicalInfoSVG,
    title: {
        key: 'Información histórica',
        plural: false
    },
    subTitle: {
        key: 'Busca GPSs históricos',
        plural: false
    },
    innerRoutes: innerRoutes,
    pathChilds: innerRoutes.map(e => e.path)
};

export default Stock;
